/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableJiraProject
 */
export interface AvailableJiraProject {
    /**
     * 
     * @type {string}
     * @memberof AvailableJiraProject
     */
    cloudId: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableJiraProject
     */
    cloudName?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableJiraProject
     */
    cloudUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableJiraProject
     */
    projectId?: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableJiraProject
     */
    projectKey: string;
    /**
     * 
     * @type {string}
     * @memberof AvailableJiraProject
     */
    projectName: string;
}

export function AvailableJiraProjectFromJSON(json: any): AvailableJiraProject {
    return {
        'cloudId': json['cloudId'],
        'cloudName': !exists(json, 'cloudName') ? undefined : json['cloudName'],
        'cloudUrl': !exists(json, 'cloudUrl') ? undefined : json['cloudUrl'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'projectKey': json['projectKey'],
        'projectName': json['projectName'],
    };
}

export function AvailableJiraProjectToJSON(value?: AvailableJiraProject): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'cloudId': value.cloudId,
        'cloudName': value.cloudName,
        'cloudUrl': value.cloudUrl,
        'projectId': value.projectId,
        'projectKey': value.projectKey,
        'projectName': value.projectName,
    };
}


